import React from 'react';

import PropTypes from 'prop-types';

import logo from 'assets/clarusLogo.png';

function ClarusLogo({ width, ...props }) {
    return (
        <img
            src={logo}
            width={width}
            alt="Clarus Logo"
            style={{ cursor: 'default' }}
            {...props}
        />
    );
}

ClarusLogo.propTypes = {
    width: PropTypes.string,
};

ClarusLogo.defaultProps = {
    width: '50px',
};
export default ClarusLogo;
